import React, {Fragment} from 'react'

import Loadable from 'react-loadable'
import {Router, Switch, Route} from 'react-router-dom'
import {Helmet} from 'react-helmet'
import {LocaleProvider} from 'antd'
import locale from 'antd/lib/locale-provider/zh_CN'
import {initStore} from 'services/store'
import {APP_NAME, APP_VERSION, APP_DESCRIPTION, APP_SHA} from 'services/constants'
import history from 'services/history'

const Main = Loadable({
  loading: () => null,
  loader: () => import('scenes/Main')
})

function App() {
  initStore()
  return (
    <LocaleProvider locale={locale} >
      <Router history={history} >
        <Fragment>
          <Helmet>
            <meta
              name="app-meta"
              content={`name=${APP_NAME},version=${APP_VERSION},description=${APP_DESCRIPTION},sha=${APP_SHA}`}
            />
          </Helmet>
          <Switch>
            <Route
              path="/"
              component={Main}
            />
          </Switch>
        </Fragment>
      </Router>
    </LocaleProvider>
  )
}

export default App
